import { useQuery } from '@tanstack/react-query';
import { wazuhApi } from '../api/wazuh';

export function useWazuhSummary() {
  return useQuery({
    queryKey: ['wazuh', 'summary'],
    queryFn: wazuhApi.getSummary,
    refetchInterval: 30_000,
    staleTime: 15_000,
    retry: false,
  });
}

export function useWazuhAgents(params: { status?: string; limit?: number }) {
  return useQuery({
    queryKey: ['wazuh', 'agents', params],
    queryFn: () => wazuhApi.getAgents(params),
    refetchInterval: 30_000,
    retry: false,
  });
}

// Device fan-out on the backend is more expensive (several syscollector calls per
// device), so this refetches far less often than agent status.
export function useDevices(limit?: number) {
  return useQuery({
    queryKey: ['wazuh', 'devices', limit],
    queryFn: () => wazuhApi.getDevices(limit),
    refetchInterval: 5 * 60_000,
    retry: false,
  });
}
